// Shared UI constants.
export const GRANULARITIES = [
  { value: 'day', label: 'Daily' },
  { value: 'month', label: 'Monthly' },
  { value: 'year', label: 'Yearly' },
];

// Categorical palette ordered so ADJACENT items contrast strongly (warm/cool
// alternation) — every slice/bar is easy to tell apart, while staying tasteful.
export const CHART_COLORS = [
  '#2563eb', // blue (brand lead)
  '#f59e0b', // amber
  '#14b8a6', // teal
  '#a855f7', // purple
  '#ef4444', // red
  '#0ea5e9', // sky
  '#84cc16', // lime
  '#ec4899', // pink
  '#f97316', // orange
  '#6366f1', // indigo
  '#10b981', // emerald
  '#eab308', // yellow
];
